/**
 * Gets the first HTML element according to the given root element and tag name.
 * @param {Element} el Root element from the tag is going to be grabbed.
 * @param {string} name Name of the tag we want to get.
 */
export function getFirstElementOf(el, name) {
  let element;

  if (
    el &&
    el.tagName &&
    Object.prototype.toString.call(el.tagName) === '[object String]' &&
    name &&
    Object.prototype.toString.call(name) === '[object String]'
  ) {
    const $name = name.toLowerCase();
    const inputs = el.getElementsByTagName($name);
    // eslint-disable-next-line prefer-destructuring
    return inputs[0];
  }

  return element;
}

export function dispatchEvent(el, name) {
  if (
    el &&
    el.dispatchEvent &&
    Object.prototype.toString.call(el.dispatchEvent) === '[object Function]' &&
    name &&
    Object.prototype.toString.call(name) === '[object String]'
  ) {
    // Create the event.
    const event = document.createEvent('Event');
    // Define that the event name is 'build'.
    event.initEvent(name, true, true);

    el.dispatchEvent(event);
  }
}

/**
 * Get the element using its selector, if element is sent it will returned.
 * @param {String|Element} selector element selector.
 */
function getElement(selector) {
  const parent =
    Object.prototype.toString.call(selector) === '[object String]' ? document.querySelector(selector) || {} : selector;

  return parent;
}

/**
 * Scroll to a desired element, if the element does not exists, then scrolls to
 * the point (0, 0) of the window
 * @param {String|Element} elementSelector CSS selector to find the element or element to scroll
 * @param {Object} offSet Offset to be added in top, bottom, left and right positions.
 */
export function scrollTo(elementSelector = {}, offSet = {}) {
  const isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;
  const element = getElement(elementSelector);
  const options = {
    behavior: 'smooth',
    left: 0,
    top: 0,
  };

  if (element.getBoundingClientRect) {
    const clientRect = element.getBoundingClientRect();
    const bodyRect = document.body.getBoundingClientRect();
    const offsetTop = offSet.top || 0;
    options.left = clientRect.left || 0;
    options.top = Math.abs((bodyRect.top || 0) - (clientRect.top || 0) + offsetTop);
  }

  if (isSmoothScrollSupported) {
    window.scrollTo(options);
  } else {
    window.scrollTo(options.left, options.top);
  }
}

/**
 * Scroll to a desired element in a static container.
 *
 * clientRect.top won't work in a static parent, so need to check using label.offsetTop.
 *
 * @param {String|Element} elementSelector CSS selector to find the element or element to scroll.
 * @param {String|Element} parentSelector CSS selector to find the parent to scroll in.
 * @param {Object} offSet Offset to be added in top, bottom, left and right positions.
 */
export function scrollToStaticContainer(elementSelector = {}, parentSelector = {}, offSet = {}) {
  const isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;
  const element = getElement(elementSelector);
  const parent = getElement(parentSelector);
  const options = {
    behavior: 'smooth',
    left: 0,
    top: 0,
  };

  if (parent && element) {
    const clientRect = element.getBoundingClientRect();
    const offsetTop = offSet.top || 0;
    options.left = clientRect.left || 0;
    options.top = Math.abs((parent.offsetTop || 0) - (element.offsetTop || 0)) + offsetTop;
  }

  if (isSmoothScrollSupported) {
    parent.scrollTo(options);
  } else {
    parent.scrollTo(options.left, options.top);
  }
}
